import { Directive, Input, TemplateRef } from '@angular/core';

@Directive({
    selector: '[templateDirective]',
})
export class TemplateDirective {
    @Input() set templateDirective(val) {
        this.name = val;
    }
    name: string;
    constructor(public template: TemplateRef<any>) {}
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./node_modules/angular-router-loader/src?loader=system&genDir=compiled&aot=false!./src/app/utils/template.directive.ts